import { useState } from 'react';
import { useNavigate } from 'react-router';
import { Logo } from '../components/Logo';
import { googleSignIn } from '../lib/firebase';

export function Login() {
  const [loading, setLoading] = useState(false);
  const [err, setErr] = useState<string | null>(null);
  const nav = useNavigate();

  async function onClick() {
    setErr(null);
    setLoading(true);
    try {
      await googleSignIn();
      nav('/');
    } catch (e) {
      const code = (e as { code?: string }).code;
      if (code === 'auth/popup-blocked') {
        setErr('Habilita popups y reintenta.');
      } else if (code !== 'auth/popup-closed-by-user') {
        setErr('No pudimos iniciar sesión, intenta de nuevo.');
      }
    } finally {
      setLoading(false);
    }
  }

  return (
    <div className="h-screen flex items-center justify-center px-6">
      <div className="max-w-[480px] w-full text-center">
        <div className="mx-auto mb-8 inline-flex">
          <Logo />
        </div>
        <h1 className="text-2xl font-bold mb-2">Catálogo Stalvi</h1>
        <p className="text-text-secondary mb-8">Comparador interno de precios</p>
        <button type="button" className="btn btn-primary btn-lg w-full" onClick={onClick} disabled={loading}>
          {loading ? 'Conectando…' : 'Iniciar sesión con Google'}
        </button>
        {err && (
          <p role="alert" className="mt-4 text-danger text-sm">
            {err}
          </p>
        )}
      </div>
    </div>
  );
}
